import { useState } from 'react';
import { addDoc, collection } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import './MonetizeModal.css';

function MonetizeModal({ isOpen, onClose, projectTitle, codeSegments }) {
  const [listingDetails, setListingDetails] = useState({
    title: projectTitle || '',
    price: '',
    description: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { user } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user || !codeSegments) return;

    setIsSubmitting(true);
    try {
      // Create marketplace listing
      const listingData = {
        userId: user.uid,
        sellerName: user.displayName || 'Anonymous',
        title: listingDetails.title,
        price: parseFloat(listingDetails.price),
        description: listingDetails.description,
        code: {
          html: codeSegments.html || '',
          css: codeSegments.css || '',
          js: codeSegments.js || ''
        },
        createdAt: Date.now(),
        status: 'active',
        purchases: 0
      };

      await addDoc(collection(db, 'marketplace'), listingData);
      onClose();
      alert('Your app has been listed in the marketplace!');
    } catch (error) {
      console.error('Error creating marketplace listing:', error);
      alert('Failed to create marketplace listing. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="monetize-modal">
        <button className="close-button" onClick={onClose}>×</button>
        <h2>List Your App in Marketplace</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Title</label>
            <input
              type="text"
              value={listingDetails.title}
              onChange={(e) => setListingDetails(prev => ({ ...prev, title: e.target.value }))}
              placeholder="Enter a catchy title for your app"
              required
            />
          </div>
          <div className="form-group">
            <label>Price (USD)</label>
            <input
              type="number"
              min="0.99"
              step="0.01"
              value={listingDetails.price}
              onChange={(e) => setListingDetails(prev => ({ ...prev, price: e.target.value }))}
              placeholder="Enter price (min $0.99)"
              required
            />
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea
              value={listingDetails.description}
              onChange={(e) => setListingDetails(prev => ({ ...prev, description: e.target.value }))}
              placeholder="Describe your app and its features"
              rows={4}
              required
            />
          </div>
          <div className="modal-buttons">
            <button type="button" className="cancel-button" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="submit-button" disabled={isSubmitting}>
              {isSubmitting ? 'Publishing...' : 'Publish to Marketplace'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default MonetizeModal; 